import { Card, CardContent } from '@mui/material'
import { HajjImage } from 'components/HajjImage/HajjImage'
import { toDocumentFormat } from 'helpers/dateHelper'
import { useGetTourPackageDetails } from 'hooks/useGetTourPackageDetails'
import { Link } from 'react-router-dom'

export const TourPackageShortPreview = ({ id }) => {
    const { data: tourPackage, isLoading } = useGetTourPackageDetails(id)

    if (isLoading) {
        return <div>Загружаем турпакет...</div>
    }

    return (
        <section>
            <div className='m-t-32'>
                <div className='flex gap-16'>
                    <div style={{ borderRadius: '8px', overflow: 'hidden', flex: 0.2, width: '100px' }}>
                        <HajjImage image={tourPackage.photo} />
                    </div>
                    <div className='profile' style={{ flex: 0.7 }}>
                        <div className='m-b-8 fs-16'>
                            <Link className='color-blue' to={`/admin/tour-packages/view/${tourPackage.id}`}>{tourPackage.name}</Link>
                        </div>
                        <div className='m-t-8 fs-14'>{toDocumentFormat(tourPackage.startDate)}-{toDocumentFormat(tourPackage.endDate)}</div>
                    </div>
                </div>
            </div>
        </section>
    )
}
